import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this._onRender = () => this._initFromHash()
    document.addEventListener("turbo:render", this._onRender)
    this._initFromHash()
  }

  disconnect() {
    document.removeEventListener("turbo:render", this._onRender)
  }

  show(event) {
    this._activate(event.currentTarget.dataset.tab)
  }

  _initFromHash() {
    const hash = location.hash?.slice(1)
    const valid = this.tabTargets.map(t => t.dataset.tab)
    const initial = valid.includes(hash) ? hash : valid[0]
    this._activate(initial)
  }

  _activate(name) {
    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tab === name
      tab.setAttribute("aria-selected", String(active))
      tab.classList.toggle("border-primary", active)
      tab.classList.toggle("text-primary", active)
      tab.classList.toggle("border-transparent", !active)
      tab.classList.toggle("text-muted", !active)
    })
    this.panelTargets.forEach(panel => {
      panel.hidden = panel.dataset.tab !== name
    })
    // Toggle sidebar sections — promote and walkthrough have dedicated sidebars
    const sidebarKey = ["promote", "walkthrough"].includes(name) ? name : "default"
    this.element.querySelectorAll("[data-listing-tabs-sidebar]").forEach(el => {
      el.hidden = el.dataset.listingTabsSidebar !== sidebarKey
    })
    history.replaceState(null, "", `#${name}`)
  }
}
